const isNil = (value) => value === undefined || value === null;
const sameId = (a, b) => !isNil(a) && !isNil(b) && String(a) === String(b);

// Location label on the assessment list.
// Parents are shown by default ("Division: Community"), except the user's own
// builder, and — for a division-tier user — a community's parent division when
// that division is in userExplicitCompanyRealms.
export const getAssessmentListRealmName = (assessment, user = {}, ifBlank = '') => {
  const realm = assessment && assessment.realm;
  const realmName = (realm && realm.name) || ifBlank;
  const parent = realm && realm.parent;
  if (!parent || !parent.name) return realmName;

  const builderId = user.userBuilderRealm && user.userBuilderRealm.id;
  if (sameId(parent.id, builderId)) return realmName;

  if (user.userRealmTier === 'division' && realm.tier === 'community') {
    const companyRealms = user.userExplicitCompanyRealms || [];
    if (companyRealms.some((companyRealm) => sameId(companyRealm.id, parent.id))) return realmName;
  }

  return `${parent.name}: ${realmName}`;
};
